export default "__VITE_ASSET__xzxS0b5b__";